import { Formio } from 'formiojs';
import _ from 'lodash';

const Select = Formio.Components.components.select;

export default class CustomSelect extends Select {
    static schema(...extend) {
        return Select.schema({
            type: 'selectdropdown',
            label: 'Select Dropdown',
            key: 'selectdropdown',
        }, ...extend)
    }

    static get builderInfo() {
        return {
            title: 'Select Dropdown',
            group: 'basic',
            icon: 'th-list',
            weight: 70,
            documentation: '/userguide/#select',
            schema: CustomSelect.schema()
        };
    }

    updateItems(searchInput, forceUpdate) {
        if (!this.component.data) {
            console.warn(`Select component ${this.key} does not have data configuration.`);
            this.itemsLoadedResolve();
            return;
        }

        // Only load the data if it is visible.
        if (!this.visible) {
            this.itemsLoadedResolve();
            return;
        }

        // dataSrc values also need to be enabled/disabled in app.scss
        switch (this.component.dataSrc) {
            case 'values':
                this.setItems(this.component.data.values);
                break;
            case 'json':
                /*
               Turning off json functionality
                */
                // this.setItems(this.component.data.json);
                break;
            case 'custom':
                /*
               Turning off custom functionality
                */
                // this.updateCustomItems(forceUpdate);
                break;
            case 'resource': {
                // If there is no resource, or we are lazyLoading, wait until active.
                if (!this.component.data.resource || (!forceUpdate && !this.active)) {
                    this.itemsLoadedResolve();
                    return;
                }

                let resourceUrl = this.options.formio ? this.options.formio.formsUrl : `${Formio.getProjectUrl()}/form`;
                resourceUrl += (`/${this.component.data.resource}/submission`);

                if (forceUpdate || this.additionalResourcesAvailable || !this.serverCount) {
                    try {
                        this.loadItems(resourceUrl, searchInput, this.requestHeaders);
                    }
                    catch (err) {
                        console.warn(`Unable to load resources for ${this.key}`);
                    }
                }
                else {
                    this.setItems(this.downloadedResources);
                }
                break;
            }
            case 'url': {
                /*
                Turning off URL functionality
                 */

                // if (!forceUpdate && !this.active && !this.calculatedValue) {
                //     // If we are lazyLoading, wait until activated.
                //     this.itemsLoadedResolve();
                //     return;
                // }
                // let { url } = this.component.data;
                // let method;
                // let body;
                //
                // if (url.startsWith('/')) {
                //     // if URL starts with '/project', we should use base URL to avoid issues with URL formed like <base_url>/<project_name>/project/<project_id>/...
                //     const baseUrl = url.startsWith('/project') ? Formio.getBaseUrl() : Formio.getProjectUrl() || Formio.getBaseUrl();
                //     url = baseUrl + url;
                // }
                //
                // if (!this.component.data.method) {
                //     method = 'GET';
                // }
                // else {
                //     method = this.component.data.method;
                //     if (method.toUpperCase() === 'POST') {
                //         body = this.component.data.body;
                //     }
                //     else {
                //         body = null;
                //     }
                // }
                // const options = this.component.authenticate ? {} : { noToken: true };
                // this.loadItems(url, searchInput, this.requestHeaders, options, method, body);
                break;
            }
            case 'indexeddb': {
                /*
                Turning off db functionality
                 */

                // if (typeof window === 'undefined') {
                //     return;
                // }
                //
                // if (!window.indexedDB) {
                //     window.alert("Your browser doesn't support current version of indexedDB");
                // }
                //
                // if (this.component.indexeddb && this.component.indexeddb.database && this.component.indexeddb.table) {
                //     const request = window.indexedDB.open(this.component.indexeddb.database);
                //
                //     request.onupgradeneeded = (event) => {
                //         if (this.component.customOptions) {
                //             const db = event.target.result;
                //             const objectStore = db.createObjectStore(this.component.indexeddb.table, { keyPath: 'myKey', autoIncrement: true });
                //             objectStore.transaction.oncomplete = () => {
                //                 const transaction = db.transaction(this.component.indexeddb.table, 'readwrite');
                //                 this.component.customOptions.forEach((item) => {
                //                     transaction.objectStore(this.component.indexeddb.table).put(item);
                //                 });
                //             };
                //         }
                //     };
                //
                //     request.onerror = () => {
                //         window.alert(request.errorCode);
                //     };
                //
                //     request.onsuccess = (event) => {
                //         const db = event.target.result;
                //         const transaction = db.transaction(this.component.indexeddb.table, 'readwrite');
                //         const objectStore = transaction.objectStore(this.component.indexeddb.table);
                //         new NativePromise((resolve) => {
                //             const responseItems = [];
                //             objectStore.getAll().onsuccess = (event) => {
                //                 event.target.result.forEach((item) => {
                //                     responseItems.push(item);
                //                 });
                //                 resolve(responseItems);
                //             };
                //         }).then((items) => {
                //             if (!_.isEmpty(this.component.indexeddb.filter)) {
                //                 items = _.filter(items, this.component.indexeddb.filter);
                //             }
                //             this.setItems(items);
                //         });
                //     };
                // }
            }
        }
    }

    // This method loads values into the dropdown that users actually see. Overriding this to pass value property as a query parameter for filtering multiple components on a resource
    loadItems(url, search, headers, options, method, body) {
        options = options || {};

        // See if we should load items or not.
        if (!this.shouldLoad || (!this.itemsFromUrl && this.options.readOnly)) {
            this.isScrollLoading = false;
            this.loading = false;
            this.itemsLoadedResolve();
            return;
        }

        // See if they have not met the minimum search requirements.
        const minSearch = parseInt(this.component.minSearch, 10);
        if (
            this.component.searchField &&
            (minSearch > 0) &&
            (!search || (search.length < minSearch))
        ) {
            // Set empty items.
            return this.setItems([]);
        }

        // Ensure we have a method and remove any body if method is get
        method = method || 'GET';
        if (method.toUpperCase() === 'GET') {
            body = null;
        }

        const limit = this.component.limit || 100;
        const skip = this.isScrollLoading ? this.selectOptions.length : 0;
        const query = this.component.disableLimit ? {} : {
            limit,
            skip,
        };

        // Allow for url interpolation.
        url = this.interpolate(url, {
            formioBase: Formio.getBaseUrl(),
            search,
            limit,
            skip,
            page: Math.abs(Math.floor(skip / limit))
        });

        // Add search capability.
        if (this.component.searchField && search) {
            if (Array.isArray(search)) {
                query[`${this.component.searchField}`] = search.join(',');
            }
            else {
                query[`${this.component.searchField}`] = search;
            }
        }

        /*
         @TODO: (PROBABLY NOT AN ISSUE) this may break for multiple values... but actually maybe not since they share labels
         Co-opting this to hardcode the value property label as the "field" to be selected.
         ResourceController needs something to filter on or it will return all of a resource's submissions, even if multiple components exist.
         And if that happens, the dropdown will have a big list of "undefined" submissions because their labels don't match the label in the itemTemplate
         */
        this.component.selectFields = this.component.valueProperty.split('.')[1];

        // If they wish to return only some fields.
        if (this.component.selectFields) {
            query.select = this.component.selectFields;
        }

        // Add sort capability
        if (this.component.sort) {
            query.sort = this.component.sort;
        }

        if (!_.isEmpty(query)) {
            // Add the query string.
            url += (!url.includes('?') ? '?' : '&') + Formio.serialize(query, (item) => this.interpolate(item));
        }

        // Add filter capability
        if (this.component.filter) {
            url += (!url.includes('?') ? '?' : '&') + this.interpolate(this.component.filter);
        }

        // Set ignoreCache if it is
        options.ignoreCache = this.component.ignoreCache;

        // Make the request.
        options.header = headers;
        this.loading = true;

        Formio.makeRequest(this.options.formio, 'select', url, method, body, options)
            .then((response) => {
                this.loading = false;
                this.error = null;
                this.setItems(response, !!search);
            })
            .catch((err) => {
                if (this.itemsFromUrl) {
                    this.setItems([]);
                    this.disableInfiniteScroll();
                }

                this.isScrollLoading = false;
                this.handleLoadingError(err);
            });
    }
}

CustomSelect.editForm = (...args) => {
    const editForm = Select.editForm(...args);
    const templateComponent = Formio.Utils.getComponent(editForm.components, 'template');

    // After selecting a value property to load in, this changes the component's template's value to that property, allowing the dropdown that users see to load the component's values instead of undefined
    templateComponent.calculateValue = (context) => {
        if (!context.data.template) {
            if (context.instance && context.instance._currentForm.options.editComponent) {
                return context.instance._currentForm.options.editComponent.template;
            }
        }

        //@TODO: find a component.update() method or equivalent instead of doing this, but this works for now
        // Handles switching data source from Values -> Resources -> Values
        if (context.data.dataSrc === "values") {
            context.data.template = '<span>{{ item.label }}</span>';

            let text = document.getElementsByClassName('ace_text ace_xml');
            if (text[0]) {
                text[0].innerHTML = context.data.template;
            }
        }

        return context.data.template;
    }

    return editForm;
}


